<mat-icon [class.current-special]="isCurrent"
          [class.future-special]="isFuture"
          [class.expired-special]="isExpired"
          [matTooltip]="tooltip"
          [svgIcon]="icon">
</mat-icon>
